type Stringable = string | number
type ApiPrefix = 'protected' | 'public'

export function endpoints<T extends ApiPrefix>(prefix: T) {
  const path = `${prefix}_api`

  return (
    {
      protected: {
        getAll: (spotId: Stringable) =>
          `/${path}/get_series_for_spot/${spotId}`,
        getProducts: (spotId: Stringable, status: 'all' | 'filtered') =>
          `/${path}/get_products/${spotId}/${status}`,
        getSeries: (spotId: Stringable, productId: Stringable) =>
          `/${path}/get_series_for_product_select/${spotId}/${productId}`,
        getSeriesForEvent: (spotId: Stringable, productId: Stringable) =>
          `/${path}/get_series_for_product/${spotId}/${productId}`,
        getOrders: (spotId: Stringable, serieId: Stringable) =>
          `/${path}/get_tickets_for_serie/${spotId}/${serieId}`,
        getSettings: (spotId: Stringable) =>
          `/${path}/get_order_settings/${spotId}`,
        saveSettings: (spotId: Stringable) =>
          `/${path}/save_order_setting/${spotId}`,
        saveSeriesForEvent: (spotId: Stringable, productId: Stringable) =>
          `/${path}/save_series_for_product/${spotId}/${productId}`,
        getTicketStatus: (spotId: Stringable, uid: string) =>
          `/${path}/get_ticket/${spotId}/${uid}`,
        saveTicketStatus: (spotId: Stringable) =>
          `/${path}/redeem_ticket/${spotId}`,
        issueRefund: (spotId: Stringable) => `/${path}/refund_ticket/${spotId}`,
        resendTicket: (spotId: Stringable) =>
          `/${path}/send_one_ticket_to_consumer/${spotId}`,
      },
      public: {
        getInitialContext: (spotId: Stringable, productId: Stringable) =>
          `/${path}/get_series_for_product/${spotId}/${productId}`,
        createOrder: (spotId: Stringable) => `${path}/create_order/${spotId}`,
        makePayment: (spotId: Stringable) => `${path}/payment/${spotId}`,
        getLogo: (spotId: Stringable) => `${path}/logo/${spotId}`,
        getProductItems: (
          spotId: Stringable,
          orderId: Stringable,
          uid: string,
        ) => `${path}/tickets/${spotId}/${orderId}/${uid}`,
      },
    } as const
  )[prefix]
}
